module.exports = {
   SECRET_KEY: "9wos0-Xo-dkm-5d11isjm-1298-kao9-prpt-fe85b7-quhxn856fb3-aksAOPLS",
   API_URL: process.env.REACT_APP_API_URL || "https://devapi.ordr.exchange/v1", // Dev server
   DWOLLA_API_BASE: "https://3.136.51.134:3000/v1",




   API_CALL_TIMEOUT: 30000,
   NEWS_FEED_API_KEY: "mn5g7HzsyPFu4ztfK7eEM1G_gUVkCk2Y9HgkMY6vhUM",
   OIL_DATA_API_KEY: "PA22ZUBCYXSJCDKJ",


   ROLE_SELLER: 2,
   ROLE_LOGISTIC: 4,
   ROLE_COMMON_CARRIER: 6,
   MAP_CONFIG: {
      default_location: {
         lat: 43.0,
         lng: -75.0,
      },
      zoom: 14,
   },
   driverTimeSlots: ["4 AM - 8 AM", "8 AM - 12 PM", "12 PM - 4 PM", "4 PM - 8 PM", "8 PM - 12 AM", "12 AM - 4 AM"],


   DWOLLA_URL: "https://api-sandbox.dwolla.com",


   HEADER_ROUTE_LIST: ["open-orders", "drivers", "orders-in-progress", "bids", "openorders", "prevorders", "assign-driver", "BOL", "profile", "notifications", "account-settings", "change-password", "invite", "manage-users", "manage-invitations", "chat", "get-help", "feedback", "auto-pricing", "freight-rates", "dwolla", "past-orders"],


   DASHBOARD_ROUTE_LIST: ["account-settings", "change-password", "profile", "notifications", "invite", "manage-users", "manage-invitations", "get-help", "feedback", "auto-pricing", "freight-rates", "dwolla", "owner-details", "controller-details", "add-bank-account", "add-bank-account-dwolla", "manage-funding-methods", "money-transfer", "transactions", "company", "terminals", "op-settings", "closed-orders", "carrier-freight-rates"],


   OPEN_ORDER_STATUS_LIST: ["Confirmed", "Pending Seller Confirmation (Awarded)", "Bid Submitted"],


   PREVIOUS_ORDER_STATUS_LIST: ["Bid Rejected", "Delivered"],


   CHAT_OPTION_LIST: ["Pending Seller Confirmation (Awarded)", "Confirmed", "Awarded", "Driver Accepted", "En-Route"],
   CHAT_OPTION_LIST_SELLER: ["Order Confirmed", "Arrived at Terminal", "Product Loaded", "BOL Uploaded", "Driver Enroute", "Order Delivered"],
   CHAT_OPTION_LIST_LOGS_MGR: ["Driver Assigned", "Driver Accepted", "Denied Duty", "Arrived at Terminal", "Product Loaded", "BOL Uploaded", "Driver Enroute", "Order Delivered"],
   RECAPTCHA_KEY: "",




   OWNER_TYPES: ["owner", "controller"],
   BID_REQUEST_TYPE: {
      NEW_BIDS: "bidRequest",
      ORDERS_IN_PROGRESS: "ordersInProgress",
      CLOSED_ORDERS: "closedOrders",
      OPEN_ORDER: "openOrder",
      PREVIOUS_ORDER: "pastOrder",
   },
   API_TIMEOUT: 8000, // in seconds


   FREIGHT_RATE_MILEAGE_RANGE_OPTIONS: [
      {
         id: 1,
         from: 1,
         to: 5,
      },


      {
         id: 2,
         from: 6,
         to: 10,
      },


      {
         id: 3,
         from: 11,
         to: 15,
      },


      {
         id: 4,
         from: 16,
         to: 20,
      },


      {
         id: 5,
         from: 21,
         to: 25,
      },


      {
         id: 6,
         from: 26,
         to: 30,
      },


      {
         id: 7,
         from: 31,
         to: 35,
      },


      {
         id: 8,
         from: 36,
         to: 40,
      },


      {
         id: 9,
         from: 41,
         to: 45,
      },


      {
         id: 10,
         from: 46,
         to: 50,
      },
   ],


   ORDER_DETAILS_OBJECT: {
      id: "",
      productType: [
         {
            Title: "",
         },
      ],
      otherNotes: "",
      deliveryDate: "",
      awardedDate: "",
      orderSize: "",
      locationDetails: {
         streetAddress: "",
         city: "",
         state: "",
         zip: "",
      },
      sellerBidPriceDetail: {
         sellerBidPriceDetail: {
            bidPricePerGallon: 0,
            quantity: 0,
            wholePriceOfQuantity: 0,
            perMilePrice: 0,
            totalDistanceInMile: 0,
            freightCharges: 0,
            totalPrice: 0,
         },
      },
      driverInfo: {},
   },




   deliveryAssignTiming: [
      {
         id: "deliveryAssignTiming-01",
         Title: "4 - 8 AM",
         value: "4-8"
      },
      {
         id: "deliveryAssignTiming-02",
         Title: "8 AM - 12 PM",
         value: "8-12"
      },
      {
         id: "deliveryAssignTiming-03",
         Title: "12 - 4 PM",
         value: "12-16"
      },
      {
         id: "deliveryAssignTiming-04",
         Title: "4 - 8 PM",
         value: "16-20"
      },
      {
         id: "deliveryAssignTiming-05",
         Title: "8 PM - 12 AM",
         value: "20-24"
      },
      {
         id: "deliveryAssignTiming-06",
         Title: "12 - 4 AM",
         value: "0-4"
      },
      {
         id: "deliveryAssignTiming-07",
         Title: "Any available",
         value: "0-24"
      }
   ],


   STATUS_INFO: {
      1: "Bid created ",
      2: "Buyer Approved",
      3: "Bid confirmed",
      4: "Buyer approves bid",
      5: "Seller Bid Awarded",
      6: "Bid delivered",
      7: "Bid Payment Success",
      8: "Bid Confirmation Cancelled",
      9: "Driver Requested",
      10: "Delivery scheduled",
      11: "Delivery Rejected",
      12: "Arrived at terminal",
      13: "Collected BOL",
      14: "Driver received Product & Delivery",
      15: "Driver en route to buyer location",
      16: "Bid Awarded from Seller",
      19: "Cancellation Requested", // Cancellation Request raised by Buyer to system
      20: "Cancellation Requested", // Cancellation Request raised by Buyer to Seller (because product delivery started)
      21: "Order Cancelled", // Cancellation Approved from system for buyer
      22: "Order Cancelled", // Cancellation Approved from Seller for buyer
      23: "Cancellation Requested Rejected", //  Cancellation Requested Rejected From System for buyer
      24: "Cancellation Requested Rejected", //  Cancellation Requested Rejected From Seller for buyer
      25: "Delivery Delayed",
      26: "Reconciliation Pending",
      27: "Payment Initiated To Seller",
      28: "Initiated Payment failed for Seller",
      29: "Payment Initiated To Ordr",
      30: "Initiated Payment failed for Ordr",
      31: "Payment Settlement Done to Seller",
      32: "Payment Settlement Done to Ordr",
      33: "Bid Locked Amount released",
      34: "Order completed"
   },


   BID_REQUEST_STATE: {
      "created": 1,
      "approve": 2,// buyer approve // Order -> but to confirm from seller side (pending order stater) 
      "confirmationFromSeller": 3, // buyer approve //Order -> seller gives confirmation against bid 
      "confirmationAwarded": 4, //confirmation awarded from buyer side
      "confirmationClosed": 5,// buyer approve //Order -> seller gives confirmation against bid and confirmed locked against bid (Confirmation)
      "delivered": 6, // buyer approve //Order -> seller confirmation && product delivered to buyer
      "deliveredAndPaymentSettlement": 7,// buyer approve //Order -> seller confirmation && product delivered to buyer && payment settlement completed
      "cancelled": 8, // confirmation cancelled
      "bidRequestAwardingTiming": 5,
      "driverRequested": 9,
      "driverAccepted": 10,
      "driverRejected": 11,
      "driverArrivedAtTerminal": 12,
      "driverCollectedBOL": 13,
      "driverReceivedProduct": 14,
      "driverEnRoute": 15,
      "confirmationAwardedFromSystem": 16, // shortlisted from system
      "unShortlistedFromSystem": 17, // shortlisted from system
      "withdrawBidFromBuyer": 18, // withdraw bid frm buyer side (None of bid selected from buyer side)
      "cancellationRequestForSystemFromBuyer": 19,
      "cancellationRequestForSellerFromBuyer": 20,
      "cancellationApprovedFromSystemForBuyerRequest": 21,
      "cancellationApprovedFromSellerForBuyerRequest": 22,
      "cacellationRejectedFromSystem": 23,
      "cancellationRejectedFromSeller": 24,
      "deliveryDelayed": 25
   },


   timeRemainingToSubmitBidInMins: 5,


   exception: {
      wordsInSentence: ["CSS", "JavaScript", "PHP"]
   },


   GOOGLE_RECAPTCHA_V3_CLIENT_KEY: process.env.REACT_APP_GOOGLE_RECAPTCHA_V3_CLIENT_KEY,
};
